<template>
  <b-container fluid>
    <div class="tabela">
    <b-row>      
      <div class="dados">
        <h5 class="inscritos">Inscritos na palestra: {{ items.length }}</h5>
        <h5 class="inscritos ufla">Inscritos da UFLA: {{ inscritosUfla }}</h5>
      </div>
    <div class="botao">
          <ButtonFill
            @click="onClickExportar"
            :showSpinner="showSpinner"
            texto="Exportar"
            class="ml-auto"
          ></ButtonFill>
    </div>
    </b-row>
      <b-table
        responsive
        :items="items"
        :fields="fields"
        caption-top
        hover
        fixed="true"
        boordeless="true"
        outlined="true"
      ></b-table>
    </div>
  </b-container>
</template>

<script>
import { listarInscritos } from "@/services/api/Palestra";
import ButtonFill from "@/components/Button-fill.vue";
import { baseUrl } from "@/config/constants";
import { GetCookie } from "@/utils/CookieUtil";
export default {
  components: {
    ButtonFill
  },

  data() {
    return {
      fields: [
        { label: "Nome", key: "user.name" },
        { label: "CPF", key: "user.cpf" },
        { label: "Email", key: "user.email" },
        { label: "LinkedIn", key: "user.linkedIn" },
        { label: "Matrícula", key: "user.studentCode" },
        { label: "Curso", key: "user.course" },
      ],
      items: [],
    };
  },
  beforeCreate() {
    const idPalestra = this.$route.params.idPalestra;
    listarInscritos(idPalestra).then((res) => {
      this.items = res.data.inscritos;
    });
  },
  computed: {
    inscritosUfla() {
      return this.items.filter((item) => item.user.estudanteUfla)
        .length;
    },
  },
  methods: {
    onClickExportar() {
      const idPalestra = this.$route.params.idPalestra;
      window.open(
        `${baseUrl}/exportar/inscritos-palestra/${idPalestra}?token=${GetCookie("token")}`,
      )}
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed");

html,
body {
  font-family: "Roboto Condensed", sans-serif;
}

.inscritos {
  display: inline;
  font-weight: 500;
}

.ufla {
  padding-left: 100px;
}

.dados {
  margin-bottom: 50px;
}

.tabela {
  padding: 5%;
  padding-top: 10%;
  font-weight: 400;
  font-size: 1em;
}

.botao{
  margin-left: 400px;
}

</style>
